module.exports = __webpack_public_path__ + "static/media/Cafe Theater Festival Logo.22230388.png";